<template>
    <!-- User Sections -->
    <ul class="navbar-nav ml-auto mb-2 mb-lg-0">
        <li v-if="user" class="nav-item dropdown mr-2">
            <router-link to="#" class="nav-link dropdown-toggle" id="navbar-dropdown-trackps" role="button"
                data-bs-toggle="dropdown" aria-expanded="false">
                {{ user.nama_pegawai }}
            </router-link>
            <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbar-dropdown-trackps">
                <li class="nav-item">
                    <button to="#" class="dropdown-item" @click="logout"><i class="fa fa-sign-out"></i>
                        Logout</button>
                </li>
            </ul>
        </li>
    </ul>
</template>

<script>
import { mapState , mapMutations } from 'vuex'

export default {
    computed: {
        ...mapState({
            access_token: state => state.access_token,
            user: state => state.user,
        })
    },
    methods: {
        ...mapMutations(['removeAuth']),
        logout() {
            const uri = '/api/logout'
            this.removeAuth()
            // this.axios.post(uri, {
            //     headers: {
            //         'Authorization': 'Bearer ' + this.access_token
            //     }
            // }).then(response => {
            //     if (response.data.status == 'success') {
            //         const payload = {
            //             auth_status: false,
            //             access_token: null,
            //             user: []
            //         }
            //         this.$store.commit('setAuth', payload)
            //         location.href = '/login'
            //     } else {
            //         this.$swal.fire({
            //             title: 'Error!',
            //             text: 'Username atau Password salah',
            //             icon: 'error',
            //             confirmButtonText: 'OK'
            //         })
            //     }
            // })
        }
    }
}
</script>
